import React, { useState } from 'react';
import './StarlinkBarChart.css';

export default function StarlinkBarChart({ data, labelKey, valueKey, height = 90, color = '#D7D7CC', unit = 'GB', highlightLastColor = 'var(--color-secondary)' }) {
  const [active, setActive] = useState(null);
  const width = 400;

  if (!data || data.length === 0) {
    return <div className="sbc-empty" style={{ height }}>No usage data yet</div>;
  }

  const max = Math.max(...data.map((d) => d[valueKey]), 0.0001);
  const barWidth = width / data.length;
  const gap = Math.min(4, barWidth * 0.25);
  const activeDatum = active != null ? data[active] : null;

  return (
    <div className="sbc-wrap">
      <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height} preserveAspectRatio="none" onMouseLeave={() => setActive(null)}>
        {data.map((d, i) => {
          const barHeight = Math.max((d[valueKey] / max) * (height - 4), 1);
          const x = i * barWidth + gap / 2;
          const y = height - barHeight;
          const isActive = active === i;
          const isMostRecent = i === data.length - 1;
          return (
            <rect
              key={d[labelKey] + i}
              x={x}
              y={y}
              width={Math.max(barWidth - gap, 1)}
              height={barHeight}
              rx="0"
              fill={isMostRecent ? highlightLastColor : color}
              opacity={active == null || isActive ? 1 : 0.45}
              onMouseEnter={() => setActive(i)}
              style={{ cursor: 'pointer' }}
            />
          );
        })}
      </svg>
      {activeDatum && (
        <div className="sbc-tooltip">
          <span>{activeDatum[labelKey]}</span>
          <strong>{activeDatum[valueKey]} {unit}</strong>
        </div>
      )}
    </div>
  );
}
